/**
 * Created by skz on 2018/5/24 9:59
 */
import request from '../ajax'

/**
 * 根据openToken获取 accessToken
 * @param openToken
 * @returns {*|AxiosPromise}
 */
export function fetchAccessTokenByOpenToken (openToken) {
  return request.post({
    reqMethod: 'account.access.getChildToken',
    params: {openToken}
  })
}

/**
 * 获取微信签名
 * @param
 */
export function getWxConfig(url) {
  return request.post({
    reqMethod: 'base.wechat.getWxConfig',
    params: {
      url: url
    }
  })
}
